export default {
  appTitle: process.env.VUE_APP_TITLE,
  networkOnLine: true,
  newContentAvailable: false,
  showAddToHomeScreenModalForApple: false,
  currentStep: 0,
  url: null,
  clientIp: null,
  competitors: [],
  competitorErrors: [],
  error: []
}
